export default [
  {
    key: 'repeatFrequency',
    label: 'label.repeatFrequency',
    rules: 'required',
    cols: 12,
    type: 'single-selection',
    rows: '5',
    options: [
      {
        value: 'daily',
        name: 'label.daily'
      },
      {
        value: 'weekly',
        name: 'label.weekly'
      },
      {
        value: 'monthly',
        name: 'label.monthly'
      },
      {
        value: 'yearly',
        name: 'label.yearly'
      }
    ]
  },
  {
    key: 'repeatInterval',
    label: 'label.repeatInterval',
    type: 'number',
    rules: 'required',
    cols: 12
  }
];
